<!--
 * @Author: your name
 * @Date: 2021-03-02 11:10:59
 * @LastEditTime: 2021-03-05 09:38:28
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \aioc-vue\src\components\public\service.vue
-->
<template>
<div>
   <Apply v-if="showApply" @showApply="handleShow"  />
   <Applyxx v-if="showApplyxx" @showApplyxx="handleShowxx"/>
    <div class="feature-menu">
          <h1 class="el-icon-chat"><img src="./../../assets/image/Aiewm2.png" alt=""></h1>
          <h1 class="el-icon-qq" @click="handContactUs"></h1>
          <h1 class="el-icon-xx" @click="showApplyxx = true"></h1>
          <h1><a href="#app" class="el-icon-arrow-up"> </a></h1>
      </div>
</div>
       
        
 
</template>

<script>
import Apply from './../train/components/apply'
import Applyxx from './../train/components/apply-xx'
export default {
  data(){
    return{
      showApply:false,
      showApplyxx:false
    }
  },
  components:{
    Apply,
    Applyxx
  },
     methods: {
      //联系客服
        handContactUs(){
             window.open("http://wpa.qq.com/msgrd?v=3&uin=3073980280&site=qq&menu=yes");
        },
         handleShow(){
      this.showApply = false
    },
         handleShowxx(){
      this.showApplyxx = false
    }
  },
}
</script>

<style lang="scss" scoped>
.feature-menu {
 box-shadow: -2px 0 8px 0 rgba(0,0,0,.08);
    width: 70px;
    // height: 150px;
    background-color: #fff;
    border-radius: 16px;
    text-align: center;
    position: fixed;
    right: -2px;
    top: 50%;
    margin-top: -75px;
    padding: 10px 5px 5px;
    z-index: 111;
    .el-icon-arrow-up:before {
        display: block;
        font-size: 40px;
        margin-top: 10px;
    }
    .el-icon-chat {
      background:url(./../../assets/image/icon-chat.png)center center no-repeat;
    }
    .el-icon-qq {
      cursor: pointer;
      background:url(./../../assets/image/icon-qq.png)center center no-repeat;
    }
    .el-icon-xx{
      cursor: pointer;
      background:url(./../../assets/image/xx.png)center center no-repeat;
      background-size:30px 30px ;
    }
    h1 {
        height: 60px;
        width: 100%;
        font-size: 14px;
        padding-bottom: 10px ;
        border-bottom: 1px solid #f5f5f5;
        cursor: default;
        &:last-child {
            border-bottom:none;
        }
    }
    .el-backtop  {
      width: 100px;
    }
    img {
      position: absolute;
      top: 0;
      right: 70px;
      width: 200px;
      height: 200px;
      display: none;
    }
    .el-icon-chat:hover img{
      display: block;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/public/service.vue